<template>
    <div class="view view__trainer_list">
        <trainer-list/>
    </div>
</template>

<script>
import TrainerList from '@/components/ebs/trainers/list/TrainerList'

export default {
  components: { TrainerList },
  name: 'view-trainer-list',
  computed: {
    trainers: function () {
      return this.$store.getters['getTrainers']
    }
  },
  watch: {
    trainers: function () {
      if (this.trainers !== '') {
        this.$eventBus.$emit('stop-loading')
      }
    }
  },
  methods: {
    getTrainers () {
      this.$store.dispatch('getTrainers')
    }
  },
  created () {
    this.getTrainers()
  },
  mounted () {
    if (this.trainers === '') {
      this.$eventBus.$emit('start-loading')
    }
  }
}
</script>
